import { Injectable } from '@angular/core';
import { from, Observable } from 'rxjs';
import { TimeFrameDto, TimeFrameTypeDto } from 'webcommon/shared';
import {ApModalService} from '../modals/index';
import { ApTimeFrameSelectorModalComponent } from './ap-timeframe-selector-modal.component';

@Injectable({
  providedIn: 'root',
})
export class ApTimeFrameSelectorModalService {
  constructor(private apModalService: ApModalService) { }

  openModal(patientId: string, visitId: string, baseId: string, selectedTimeFrameId: string | undefined | null, selectedTimeFrameValue: any,
            bUsePatient: boolean | null, altDate: TimeFrameTypeDto | null, timeFrameDtos: TimeFrameDto[],
  ): Observable<TimeFrameTypeDto> {

    const aDate = altDate ? altDate.Date.toString() : null;
    const initialState = {
      aDate,
      bUsePatient,
      baseId,
      patientId,
      selectedTimeFrameId,
      selectedTimeFrameValue,
      timeFrameDtos,
      visitId,
    };
    const p = this.apModalService.showComponentModal(ApTimeFrameSelectorModalComponent, {
      class: 'modal-sm',
      ignoreBackdropClick: true,
      initialState,
    });
    return from(p);
  }
}
